import { 
  getAssetConfig,
  getAssetList,
  getPurchaseDirectory,
  saveAsset,
  submitAsset,
  getDefaultInfo,
  getAssetInfo,
  deleteAsset,
  getWorkflowTemplate,
  getWorkflowInstance,
  submitWorkflow,
  auditWorkflow,
  canceWlorkflow,
  nullifyAsset,
  forwardAsset
} from '../services';

// 递归遍历数据
const formatMenusTree = (data = []) => {
  return (data || [])?.map(i => ({
    ...i,
    label: i.directoryName,
    value: i.directoryCode,
    children: (i.child && i.child.length > 0) ? formatMenusTree(i.child) : null,
  }));
};

export default {
  namespace: 'asset',
  state: {
    configList: {},
    companyInfo: {},
    purchaseData: [],
    detail: {}
  },
  effects: {
    * getAssetConfig ({ payload }, { call, put }) {
      const result = yield call(getAssetConfig, payload);
      const config = {};
      result?.forEach(ele => {
        config[ele.groupCode] = ele.configROS;
      });
      yield put({
        type: 'update',
        payload: {
          configList: config,
        },
      });
    },
    
    * getAssetList ({ payload }, { call }) {
      const result = yield call(getAssetList, payload);
      return result;
    },

    * getPurchaseDirectory ({ payload }, { call, put }) {
      const result = yield call(getPurchaseDirectory, payload);
      yield put({
        type: 'update',
        payload: {
          purchaseData: formatMenusTree(result),
        },
      });
    },

    * saveAsset ({ payload }, { call }) {
      const result = yield call(saveAsset, payload);
      return result;
    },

    * submitAsset ({ payload }, { call }) {
      const result = yield call(submitAsset, payload);
      return result;
    },

    * getDefaultInfo ({ payload }, { call, put }) {
      const result = yield call(getDefaultInfo, payload);
      const departmentList = result.departmentList?.map(
        i => ({ ...i, deptName: `${result.orgName} ${i.deptId === -1 ? '' : '- ' + i.deptName}` }
        )) || [];
      result.departmentList = departmentList;
      yield put({
        type: 'update',
        payload: {
          companyInfo: result,
        },
      });
    },

    * getAssetInfo ({ payload }, { call, put }) {
      const result = yield call(getAssetInfo, payload);
      yield put({
        type: 'update',
        payload: {
          detail: result,
        },
      });
    },
    
    * clearAssetInfo ({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          detail: {},
        },
      });
    },

    * deleteAsset ({ payload }, { call }) {
      const result = yield call(deleteAsset, payload);
      return result;
    },

    // 查询工作流模板
    * getWorkflowTemplate ({ payload }, { call }) {
      const result = yield call(getWorkflowTemplate, payload);
      return result;
    },

    // 查询工作流实例
    * getWorkflowInstance ({ payload }, { call }) {
      const result = yield call(getWorkflowInstance, payload);
      return result;
    },

    // 提交审批
    * submitWorkflow ({ payload }, { call }) {
      const result = yield call(submitWorkflow, payload);
      return result;
    },

    // 审批工作流
    * auditWorkflow ({ payload }, { call }) {
      const result = yield call(auditWorkflow, payload);
      return result;
    },

    // 撤回工作流
    * canceWlorkflow ({ payload }, { call }) {
      const result = yield call(canceWlorkflow, payload);
      return result;
    },

    * nullifyAsset ({ payload }, { call }) {
      const result = yield call(nullifyAsset, payload);
      return result;
    },
    
    * forwardAsset ({ payload }, { call }) {
      const result = yield call(forwardAsset, payload);
      return result;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};